import React from "react";
import { useTranslation } from "react-i18next";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import FooterNote from "components/Redesign/FooterNote.js";
import Cart from "views/examples/Shop/Cart.js";

function Warenkorb() {
  const { t } = useTranslation();
  const [orderComplete, setOrderComplete] = React.useState(false);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <section className="page-shell">
        <div className="wrap">
          <div className="rd-section-no">{t("warenkorb.Page label")}</div>
          <h1 className="page-shell-h1">{t("warenkorb.Page title")}</h1>
        </div>
      </section>

      <div className="shop">
        <Cart onOrderStateChange={setOrderComplete} />
      </div>

      {!orderComplete && <FooterNote />}
      <SiteFooter />
    </div>
  );
}

export default Warenkorb;
